import type { FaireProductEntity } from "../../entity_types/product";

export const p_r8vqvw5sqj: FaireProductEntity = {
  token: "p_r8vqvw5sqj",
  type: "product",
  name: "Iced Tea Little Notes®",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/61e7ef90e9a35b8cf0fa703f932de45b08a906fd4592165e58f1241ad4470738.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/39ea1852c3439ca764474cf9179fb66024effcb493846672f7bafb82af40ea5f.jpeg",
    "https://cdn.faire.com/fastly/41194c8818612dc086c65f4cf8ae1c4515eaf3440167fd56c95418e3d0453098.jpeg",
  ],
  priceDollars: 7,
  description:
    "Little Notes® are tiny in size and big on heart. Small enough to slip in a pocket, a lunch box, or a stack of books, each one carries something much larger than its size: a laugh, a love note, a small connection. Whether it’s a joke tucked into a backpack, a to-do list turned sweet, or a simple “thank you,” Little Notes® bring joy to life’s little, big and in-between moments.\n\nEvery Little Note features hand-painted watercolor illustrations, front and back, so even the simplest message feels special. With 55 per pack, you can mix, match and share freely. Over 69 million Little Notes® have already been shared worldwide, sparking connection one small gesture at a time.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:31.717Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
